// Localização: frontend/src/components/Prontuario/TimelineEvent.jsx (Versão 1.0.0)
// Componente de evento individual na timeline

import React, { useState } from 'react';
import { Clock, User } from 'lucide-react';
import { formatDateTime } from '../../utils/formatters';

/**
 * Componente de Evento Individual na Timeline
 * @param {object} event - Dados do evento
 * @param {object} colors - Cores do tipo de evento
 * @param {Component} icon - Ícone do tipo de evento
 * @param {function} onClick - Callback ao clicar
 * @param {boolean} isSelected - Se o evento está selecionado
 */
const TimelineEvent = ({ event, colors, icon: Icon, onClick, isSelected = false }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div className="relative">
            {/* Ponto na linha da timeline */}
            <div className={`absolute -left-9 top-1/2 transform -translate-y-1/2 w-4 h-4 rounded-full border-2 ${colors.border} ${colors.dot} z-10`}>
                <div className="absolute inset-0 rounded-full bg-white animate-ping opacity-20"></div>
            </div>

            {/* Card do Evento */}
            <div
                className={`
                    relative bg-white rounded-lg shadow-md border-l-4 transition-all duration-200
                    ${colors.border}
                    ${isSelected ? 'ring-2 ring-emerald-400 shadow-lg' : ''}
                    ${isHovered ? 'shadow-lg transform -translate-y-1' : 'hover:shadow-lg'}
                    cursor-pointer
                `}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={onClick}
            >
                <div className="p-4">
                    {/* Cabeçalho do Evento */}
                    <div className="flex items-start gap-3">
                        {/* Ícone */}
                        <div className={`p-2 rounded-lg ${colors.bg} flex-shrink-0`}>
                            <Icon className={`w-5 h-5 ${colors.text}`} />
                        </div>

                        {/* Conteúdo */}
                        <div className="flex-1 min-w-0">
                            <h4 className={`font-semibold ${colors.text} mb-1`}>
                                {event.titulo}
                            </h4>
                            
                            {event.descricao && (
                                <p className="text-sm text-gray-600 line-clamp-2 mb-2">
                                    {event.descricao}
                                </p>
                            )}

                            {/* Metadados */}
                            <div className="flex flex-wrap items-center gap-3 text-xs text-gray-500 mt-2">
                                <div className="flex items-center gap-1">
                                    <Clock className="w-3 h-3" />
                                    <span>{formatDateTime(event.data_hora)}</span>
                                </div>
                                
                                {event.usuario_nome && (
                                    <div className="flex items-center gap-1">
                                        <User className="w-3 h-3" />
                                        <span>{event.usuario_nome}</span>
                                    </div>
                                )}
                                
                                {event.categoria && (
                                    <span className="px-2 py-0.5 bg-gray-100 rounded">
                                        {event.categoria}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tooltip ao Hover */}
                {isHovered && (
                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 z-20">
                        <div className="bg-gray-900 text-white text-xs rounded-lg py-2 px-3 shadow-lg max-w-xs">
                            <div className="font-semibold mb-1">{event.titulo}</div>
                            <div className="text-gray-300">{formatDateTime(event.data_hora)}</div>
                            {event.descricao && (
                                <div className="mt-1 text-gray-400 line-clamp-2">
                                    {event.descricao}
                                </div>
                            )}
                            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full">
                                <div className="w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TimelineEvent;

